import { AsyncPipe, NgClass, NgIf } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ConfigurationService } from '@sc/data-access-configuration';
import {
  AnswerChoice,
  getGlassNameDefaultKey,
  GlassUsageConfiguration,
  SinisterGlass,
} from '@sc/data-access-models';
import { TranslatorService } from '@sc/data-access-translation';
import { forkJoin } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { CarImgService } from '../../../services';

@Component({
  selector: 'sc-car-img-summary-5-lat',
  styleUrls: ['./car-img-summary-5-lat.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [CarImgService],
  imports: [NgIf, NgClass, TranslateModule, AsyncPipe],
  template: `
    <div class="car-schema-container" aria-hidden="true">
      <svg
        aria-hidden="true"
        focusable="false"
        id="car-schema"
        viewBox="0 0 408 592"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title></title>
        <g
          id="🤖-BtoB"
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
        >
          <g id="Group-Global" stroke="#9C9EB3" stroke-width="1.73289">
            <path
              d="M204.001 1.4082C203.186 1.4082 146.59 1.59882 122.555 27.6442C98.3639 53.8801 92.0908 86.1638 92.0908 86.1638V308.615L94.5862 477.97L110.633 557.614C117.79 577.404 136.574 590.608 157.611 590.608H250.356C271.41 590.608 290.195 577.421 297.334 557.614L313.381 477.97L315.876 308.615V86.1638C315.876 86.1638 309.603 53.8801 285.412 27.6442C261.429 1.59882 204.815 1.4082 204.001 1.4082Z"
              fill="#F2F5F8"
            />

            <g opacity="0.5">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M300.695 56.1861C300.695 55.8395 300.643 55.5276 300.539 55.1983C298.928 50.2422 282.968 8.01172 203.931 8.01172C124.894 8.01172 108.934 50.2249 107.322 55.1983C107.218 55.5276 107.183 55.8395 107.166 56.1861L105.433 148.341C105.364 152.257 110.84 154.736 114.046 152.5C126.886 143.524 154.734 129.626 203.913 129.626C253.093 129.626 280.94 143.524 293.781 152.5C296.987 154.736 302.48 152.257 302.394 148.341L300.661 56.1861H300.695Z"
                fill="#ECEDF0"
                stroke-miterlimit="10"
              />
              <path
                d="M299.656 56.2039C299.656 55.944 299.622 55.7187 299.552 55.5281C298.79 53.1887 294.492 41.5783 280.629 30.5745C266.766 19.5706 243.268 9.06934 203.932 9.06934C164.595 9.06934 141.097 19.5706 127.234 30.5745C113.371 41.5957 109.073 53.1887 108.311 55.5281C108.241 55.7361 108.207 55.944 108.207 56.2039L106.474 148.359C106.457 149.78 107.427 151.062 108.952 151.773C110.477 152.483 112.227 152.483 113.457 151.634C126.471 142.537 154.527 128.569 203.914 128.569C253.302 128.569 281.357 142.537 294.388 151.634C295.601 152.483 297.369 152.483 298.894 151.773C300.419 151.062 301.407 149.763 301.372 148.359L299.639 56.2039H299.656Z"
              />
            </g>

            <!-- Side Window Shadows -->
            <path
              d="M103.944 220.446V252.331L116.438 257.893C116.438 257.893 115.329 234.985 108.017 219.545C107.046 217.482 103.944 218.176 103.944 220.446Z"
              fill="#ECEDF0"
            />
            <path
              d="M103.944 362.49L116.438 368.295V265.448L103.944 260.163V362.49Z"
              fill="#ECEDF0"
            />
            <path
              d="M103.944 429.155L116.438 434.96V384.1L103.944 378.797V429.155Z"
              fill="#ECEDF0"
            />
            <path
              d="M103.944 459.36L116.438 454.959V442.031L103.944 436.729V459.36Z"
              fill="#ECEDF0"
            />
            <path
              d="M104.638 466.083L116.439 461.803V480.813C116.439 480.813 116.595 514.673 112.8 514.76C112.8 514.76 106.977 492.25 104.638 466.083Z"
              fill="#ECEDF0"
            />

            <path
              d="M305.792 220.446V252.331L293.298 257.893C293.298 257.893 294.407 234.985 301.72 219.545C302.69 217.482 305.792 218.176 305.792 220.446Z"
              fill="#ECEDF0"
            />
            <path
              d="M305.791 362.49L293.314 368.295V265.448L305.791 260.163V362.49Z"
              fill="#ECEDF0"
            />
            <path
              d="M305.791 429.155L293.314 434.96V384.1L305.791 378.797V429.155Z"
              fill="#ECEDF0"
            />
            <path
              d="M305.791 459.36L293.314 454.959V442.031L305.791 436.729V459.36Z"
              fill="#ECEDF0"
            />
            <path
              d="M305.098 466.083L293.297 461.803V480.813C293.297 480.813 293.141 514.673 296.936 514.76C296.936 514.76 302.758 492.25 305.098 466.083Z"
              fill="#ECEDF0"
            />
            <!-- --- -->

            <g id="Group-Selectable-Glasses" fill="white">
              <!-- Windshield -->
              <path
                *ngIf="'windshield' as id"
                [id]="id"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M113.006 168.094C112.937 167.661 113.041 167.228 113.352 166.916C117.338 162.757 147.265 133.645 204.814 133.645C262.364 133.645 293.833 162.653 298.13 166.899C298.46 167.228 298.581 167.678 298.494 168.146L283.644 243.648C283.47 244.497 282.621 245.017 281.789 244.775C274.165 242.505 239.49 232.749 204.797 232.749C170.105 232.749 135.551 242.47 127.857 244.757C127.008 245.017 126.141 244.463 126.003 243.596L113.006 168.094Z"
                [ngClass]="{
                  hoverable: isHoverable(id),
                  selectedGlass: isSelected(id)
                }"
                (click)="onGlassChange($event)"
              />
              <!-- --- -->

              <!-- Left Side Windows -->
              <path
                *ngIf="
                  'sideWindow-precision_custodeFrontGlass-frontConductor_left' as id
                "
                [id]="id"
                d="M54.6778 253.389L25.0107 257.738L44.783 219.442C44.783 219.442 44.8523 219.39 44.9043 219.355C45.0776 219.234 45.3202 219.06 45.6148 218.87C46.2213 218.488 47.0358 218.038 47.9195 217.726C48.8207 217.414 49.7044 217.241 50.5016 217.379C51.2467 217.501 51.9572 217.899 52.5117 218.835C53.1182 219.84 53.5514 221.365 53.8634 223.185C54.6778 228.47 54.6951 253.042 54.6778 253.389Z"
                [ngClass]="{
                  hoverable: isHoverable(id),
                  selectedGlass: isSelected(id)
                }"
                (click)="onGlassChange($event)"
              />
              <path
                *ngIf="
                  'sideWindow-precision_conductorGlass-frontConductor_left' as id
                "
                [id]="id"
                d="M54.6598 259.991V365.022L1.06152 365.524C1.4081 326.344 3.76483 309.517 12.7932 285.673C17.3507 273.646 20.4179 268.118 22.4281 264.479L54.6425 259.991H54.6598Z"
                [ngClass]="{
                  hoverable: isHoverable(id),
                  selectedGlass: isSelected(id)
                }"
                (click)="onGlassChange($event)"
              />
              <path
                *ngIf="
                  'sideWindow-precision_anotherGlass-frontConductor_left' as id
                "
                [id]="id"
                d="M1.06152 379.941L54.6945 378.642V429.485H1.06152V379.941Z"
                [ngClass]="{
                  hoverable: isHoverable(id),
                  selectedGlass: isSelected(id)
                }"
                (click)="onGlassChange($event)"
              />
              <path
                *ngIf="
                  'sideWindow-precision_anotherCustode-frontConductor_left' as id
                "
                [id]="id"
                d="M1.06152 436.572H54.6945L54.6598 460.486L1.06152 473.171V436.572Z"
                [ngClass]="{
                  hoverable: isHoverable(id),
                  selectedGlass: isSelected(id)
                }"
                (click)="onGlassChange($event)"
              />
              <path
                *ngIf="
                  'sideWindow-precision_custodeGlass-frontConductor_left' as id
                "
                [id]="id"
                d="M2.91602 480.899L54.6774 469.202L55.3359 485.353C55.3359 490.447 55.5439 512.75 50.1026 516.163C45.2505 519.196 37.5218 520.461 29.1346 517.948C27.7137 517.532 15.0809 499.268 2.91602 480.916V480.899Z"
                [ngClass]="{
                  hoverable: isHoverable(id),
                  selectedGlass: isSelected(id)
                }"
                (click)="onGlassChange($event)"
              />
              <!-- --- -->

              <!-- Right Side Windows -->
              <path
                *ngIf="
                  'sideWindow-precision_custodeFrontGlass-frontConductor_right' as id
                "
                [id]="id"
                d="M354.139 225.281C354.451 223.461 354.901 221.919 355.49 220.931C356.045 219.995 356.755 219.597 357.5 219.475C358.28 219.337 359.181 219.493 360.082 219.822C360.966 220.134 361.781 220.584 362.387 220.966C362.682 221.156 362.924 221.33 363.098 221.451C363.15 221.486 363.184 221.52 363.219 221.538L382.991 259.834L353.324 255.485C353.324 255.138 353.324 230.566 354.139 225.281Z"
                [ngClass]="{
                  hoverable: isHoverable(id),
                  selectedGlass: isSelected(id)
                }"
                (click)="onGlassChange($event)"
              />
              <path
                *ngIf="
                  'sideWindow-precision_conductorGlass-frontConductor_right' as id
                "
                [id]="id"
                d="M385.556 266.592C387.566 270.231 390.633 275.759 395.191 287.785C404.237 311.629 406.576 328.456 406.923 367.636L353.324 367.134V262.104L385.539 266.592H385.556Z"
                [ngClass]="{
                  hoverable: isHoverable(id),
                  selectedGlass: isSelected(id)
                }"
                (click)="onGlassChange($event)"
              />
              <path
                *ngIf="
                  'sideWindow-precision_anotherGlass-frontConductor_right' as id
                "
                [id]="id"
                d="M406.94 382.037L353.324 380.737V431.58H406.94V382.037Z"
                [ngClass]="{
                  hoverable: isHoverable(id),
                  selectedGlass: isSelected(id)
                }"
                (click)="onGlassChange($event)"
              />
              <path
                *ngIf="
                  'sideWindow-precision_anotherCustode-frontConductor_right' as id
                "
                [id]="id"
                d="M406.94 438.669H353.324L353.342 462.583L406.94 475.268V438.669Z"
                [ngClass]="{
                  hoverable: isHoverable(id),
                  selectedGlass: isSelected(id)
                }"
                (click)="onGlassChange($event)"
              />
              <path
                *ngIf="
                  'sideWindow-precision_custodeGlass-frontConductor_right' as id
                "
                [id]="id"
                d="M405.085 482.997L353.324 471.3L352.665 487.45C352.665 492.545 352.457 514.847 357.898 518.261C362.751 521.294 370.479 522.559 378.866 520.046C380.287 519.63 392.92 501.365 405.085 483.014V482.997Z"
                [ngClass]="{
                  hoverable: isHoverable(id),
                  selectedGlass: isSelected(id)
                }"
                (click)="onGlassChange($event)"
              />
              <!-- --- -->

              <!-- Rear Window -->
              <path
                *ngIf="'rearWindow' as id"
                [id]="id"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M128.896 468.388C128.966 467.504 129.797 466.88 130.664 467.053C138.185 468.613 170.364 474.817 204 474.817C237.635 474.817 269.832 468.613 277.336 467.053C278.202 466.88 279.034 467.504 279.103 468.388L284.648 542.815C284.683 543.387 284.406 543.924 283.886 544.167C279.103 546.472 253.387 557.649 203.982 557.649C154.578 557.649 128.862 546.472 124.079 544.167C123.559 543.924 123.282 543.387 123.316 542.815L128.862 468.388H128.896Z"
                [ngClass]="{
                  hoverable: isHoverable(id),
                  selectedGlass: isSelected(id)
                }"
                (click)="onGlassChange($event)"
              />
              <!-- --- -->

              <!-- Top Window -->
              <path
                *ngIf="'topWindow' as id"
                [id]="id"
                d="M150.229 263.161H260.493C263.525 263.161 265.969 265.674 265.969 268.776V445.738C265.969 448.84 263.508 451.353 260.493 451.353H150.229C147.196 451.353 144.753 448.84 144.753 445.738V268.776C144.753 265.674 147.214 263.161 150.229 263.161Z"
                [ngClass]="{
                  hoverable: isHoverable(id),
                  selectedGlass: isSelected(id)
                }"
                (click)="onGlassChange($event)"
              />
              <!-- --- -->

              <!-- Mirrors -->
              <path
                *ngIf="'mirror-mirror_left' as id"
                [id]="id"
                d="M104.238 190.779C106.231 186.083 106.785 181.525 106.941 179.671H107.427L110.477 207.241C110.477 207.241 110.425 207.259 110.407 207.276C110.338 207.31 110.269 207.31 110.217 207.31C108.692 205.959 106.335 204.538 103.476 205.127C100.859 205.664 99.8886 208.056 99.5766 210.135C99.2647 212.197 99.4727 214.346 99.6286 215.403L73.9472 228.33C73.1674 224.085 74.5017 219.007 77.6383 214.363C80.8441 209.615 85.8868 205.387 92.2985 203.03C98.6236 200.691 102.228 195.613 104.273 190.779H104.238Z"
                [ngClass]="{
                  hoverable: isHoverable(id),
                  selectedGlass: isSelected(id)
                }"
                (click)="onGlassChange($event)"
              />
              <path
                *ngIf="'mirror-mirror_right' as id"
                [id]="id"
                d="M304.993 190.779C303 186.083 302.445 181.525 302.289 179.671H301.821L298.771 207.241C298.771 207.241 298.823 207.259 298.841 207.276C298.91 207.31 298.979 207.31 299.031 207.31C300.556 205.959 302.913 204.538 305.772 205.127C308.389 205.664 309.359 208.056 309.671 210.135C309.983 212.197 309.775 214.346 309.619 215.403L335.301 228.33C336.081 224.085 334.746 219.007 331.61 214.363C328.404 209.615 323.361 205.387 316.949 203.03C310.624 200.691 307.02 195.613 304.975 190.779H304.993Z"
                [ngClass]="{
                  hoverable: isHoverable(id),
                  selectedGlass: isSelected(id)
                }"
                (click)="onGlassChange($event)"
              />
              <!-- --- -->

              <!-- Front Lights -->
              <path
                *ngIf="'lights-lightsEmplacement_front-lateral_left' as id"
                [id]="id"
                d="M124.131 34.4728C126.505 31.9601 131.669 27.3853 141.027 22.7412C152.256 17.1786 159.794 16.1215 162.289 15.9136V7.5957C138.687 10.9922 125.794 26.3802 124.131 28.477V34.4555V34.4728Z"
                [ngClass]="{
                  hoverable: isHoverable(id),
                  selectedGlass: isSelected(id)
                }"
                (click)="onGlassChange($event)"
              />
              <path
                *ngIf="'lights-lightsEmplacement_front-lateral_right' as id"
                [id]="id"
                d="M285.29 34.4728C282.916 31.9601 277.752 27.3853 268.394 22.7412C257.165 17.1786 249.645 16.1215 247.132 15.9136V7.5957C270.734 10.9922 283.627 26.3802 285.29 28.477V34.4555V34.4728Z"
                [ngClass]="{
                  hoverable: isHoverable(id),
                  selectedGlass: isSelected(id)
                }"
                (click)="onGlassChange($event)"
              />
              <!-- --- -->

              <!-- Rear Lights -->
              <path
                *ngIf="'lights-lightsEmplacement_rear-lateral_left' as id"
                [id]="id"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M120.406 557.961C119.782 557.32 118.482 557.788 118.482 558.689V564.459C118.482 564.65 118.552 564.841 118.656 564.997C120.337 567.128 133.801 583.313 158.53 586.866C159.067 586.935 159.552 586.519 159.552 585.964V577.387C159.552 576.884 159.153 576.468 158.651 576.434C156.138 576.226 148.548 575.134 137.18 569.519C128.048 564.997 122.884 560.543 120.389 557.961H120.406Z"
                [ngClass]="{
                  hoverable: isHoverable(id),
                  selectedGlass: isSelected(id)
                }"
                (click)="onGlassChange($event)"
              />
              <path
                *ngIf="'lights-lightsEmplacement_rear-lateral_right' as id"
                [id]="id"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M271.115 569.519C259.747 575.151 252.157 576.226 249.644 576.434C249.142 576.468 248.743 576.884 248.743 577.387V585.964C248.743 586.519 249.228 586.935 249.766 586.866C274.494 583.331 287.958 567.145 289.639 564.997C289.761 564.841 289.813 564.65 289.813 564.459V558.689C289.813 557.788 288.513 557.32 287.889 557.961C285.394 560.526 280.23 564.979 271.097 569.519H271.115Z"
                [ngClass]="{
                  hoverable: isHoverable(id),
                  selectedGlass: isSelected(id)
                }"
                (click)="onGlassChange($event)"
              />
              <!-- --- -->
            </g>
          </g>
        </g>
      </svg>

      <div class="sc-conf-display-car-img-summary-description">
        <div>
          {{ 'GlobalApplicativeConstants.youHaveSelected' | translate }}
        </div>
        <div class="glass-list">
          {{
            (formatGlassesToDisplay() | async) ||
              ('GlobalApplicativeConstants.sinisterGlass.glass.none'
                | translate)
          }}
        </div>
      </div>
    </div>
  `,
})
export class CarImgSummaryComponent5Lat {
  @Input() glasses: SinisterGlass[];
  @Input() editMode = false;

  @Output() glassChangeEvent = new EventEmitter<AnswerChoice>();

  glassUsageConfiguration: GlassUsageConfiguration;

  constructor(
    private readonly configuration: ConfigurationService,
    private readonly carImgService: CarImgService,
    private readonly translator: TranslatorService
  ) {
    this.glassUsageConfiguration = this.configuration.getGlassUsage();
  }

  isHoverable(id: string): boolean {
    return this.editMode && !!this.carImgService.getAnswerById(id);
  }

  isSelected(id: string): boolean {
    const answersToCheck = this.carImgService.getAnswerById(id);
    if (!answersToCheck) {
      return false;
    }
    return !!this.glasses.find((sinisterGlassSelected) => {
      if (sinisterGlassSelected?.glass === 'multiple') {
        return false;
      }

      if (
        !sinisterGlassSelected?.glass ||
        sinisterGlassSelected.glass !== answersToCheck.glass ||
        ((!!sinisterGlassSelected.glassExtended ||
          !!answersToCheck.glassExtended) &&
          sinisterGlassSelected.glassExtended !== answersToCheck.glassExtended)
      ) {
        return false;
      }

      let subGlass;
      switch (sinisterGlassSelected.glass) {
        case 'windshield':
        case 'rearWindow':
        case 'topWindow':
          return true;
        case 'sideWindow':
          subGlass = 'lateralPrecisions';
          break;
        case 'lights':
          subGlass = 'light';
          break;
        case 'mirror':
          return (
            !sinisterGlassSelected?.mirror ||
            sinisterGlassSelected.mirror === answersToCheck.sub?.mirror ||
            sinisterGlassSelected.mirror === 'both'
          );
        default:
          break;
      }
      return Object.keys(sinisterGlassSelected?.[subGlass] || {}).reduce(
        (result, key) =>
          result &&
          (sinisterGlassSelected[subGlass][key] === null ||
            sinisterGlassSelected[subGlass][key] === undefined ||
            sinisterGlassSelected[subGlass][key] ===
              answersToCheck.sub?.[key] ||
            sinisterGlassSelected[subGlass][key] === 'both'),
        true
      );
    });
  }

  onGlassChange($event) {
    if (!this.editMode) {
      return;
    }

    const answers = this.carImgService.getAnswerById($event.target.id);
    if (answers) {
      this.glassChangeEvent.emit(answers);
    }
  }

  formatGlassesToDisplay() {
    return forkJoin(
      this.glasses
        .filter(
          (glass, i) =>
            this.glasses.findIndex(
              (sameGlass, j) =>
                sameGlass.glass === glass.glass &&
                ((!sameGlass.glassExtended && !glass.glassExtended) ||
                  sameGlass.glassExtended === glass.glassExtended) &&
                j < i
            ) === -1
        )
        .map((glass) =>
          this.translator
            .getTranslation(getGlassNameDefaultKey(glass))
            .pipe(take(1))
        )
    ).pipe(map((glassNameKeys) => glassNameKeys?.join(', ')));
  }
}
